<template lang="pug">
.container-restricao(v-if='restricoes.length > 0')
    div(
        v-for='(restricao, index) in listaRestricoes',
        :key='`$restricao-moratoria-consolidada-${index}`',
        :class='restricoes[index].inibido ? "camada-inibida" : ""'
    )
        slot(name='botaoInibir', :restricao='restricoes[index]')
        .card-restricao
            .container-restricao-acoes(
                v-if='existeDadosGeoEspaciais(restricao)'
            )
                div
                    el-button(
                        size='small',
                        icon='mdi mdi-crosshairs-gps',
                        @click='aplicarZoomRestricao(index)'
                    )
            .restricao-id
                span.restricao-id__label Id:
                span.restricao-id__value {{ obterId(restricao) }}
            .restricao-id
                span.restricao-id__label {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.ano') }}:
                span.restricao-id__value {{ obterAno(restricao) }}
            .restricao-lista(
                v-for='(item, index) in formatarListaRestricoes(restricao)',
                :key='`$retricao-moratoria-consolidada-lista-${index}`'
            )
                .restricao-dados(
                    v-for='({ label, value }, index) in listarDados(item)',
                    :key='`$restricao-moratoria-consolidada-dados-${index}`'
                )
                    span.restricao-dados__label {{ `${label}:` }}
                    span.restricao-dados__value {{ value }}
</template>

<script>
import formatters from '@/utils/formatters';

export default {
    name: 'moratoria-soja-consolidada',
    computed: {
        listaRestricoes: function () {
            return this.restricoes.map(value => {
                if (value.properties) {
                    return {
                        ...value.properties
                    };
                }
                return value;
            });
        }
    },
    props: {
        restricoes: {
            type: Array,
            required: true
        },
        geometria: {
            type: Array,
            required: false,
            default: null
        },
        habilitarZoomRestricao: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    methods: {
        listarDados(dados) {
            const dadosRestricoes = dados?.properties || dados;

            return [
                {
                    label: this.$t(
                        'mensagens.diagnosticoSocioambiental.propriedadesCamada.fazenda'
                    ),
                    value:
                        dadosRestricoes?.fazenda ||
                        dadosRestricoes.fazenda_1 ||
                        '-'
                },
                {
                    label: this.$t(
                        'mensagens.diagnosticoSocioambiental.propriedadesCamada.proprietario'
                    ),
                    value: dadosRestricoes?.prop || '-'
                },
                {
                    label: this.$t(
                        'mensagens.diagnosticoSocioambiental.propriedadesCamada.cpfCnpj'
                    ),
                    value: this.numeralStringFormatTocpfCnpj(
                        dadosRestricoes.cpf_cnpj
                    )
                },
                {
                    label: this.$t(
                        'mensagens.diagnosticoSocioambiental.propriedadesCamada.tipo'
                    ),
                    value: dadosRestricoes?.prot_reg || '-'
                },
                {
                    label: this.$t(
                        'mensagens.diagnosticoSocioambiental.propriedadesCamada.mun'
                    ),
                    value: dadosRestricoes?.mun || '-'
                },
                {
                    label: this.$t(
                        'mensagens.diagnosticoSocioambiental.propriedadesCamada.uf'
                    ),
                    value: dadosRestricoes?.uf || '-'
                },
                {
                    label: this.$t(
                        'mensagens.diagnosticoSocioambiental.propriedadesCamada.latitude'
                    ),
                    value:
                        dadosRestricoes?.latitude || dadosRestricoes.lat || '-'
                },
                {
                    label: this.$t(
                        'mensagens.diagnosticoSocioambiental.propriedadesCamada.longitude'
                    ),
                    value:
                        dadosRestricoes?.longitude ||
                        dadosRestricoes.long ||
                        '-'
                }
            ];
        },
        obterId(restricao) {
            const dados = this.formatarListaRestricoes(restricao)[0];
            const dadosRestricoes = dados?.properties || dados;

            return dadosRestricoes.idTabela || '-';
        },
        obterAno(restricao) {
            const dados = this.formatarListaRestricoes(restricao)[0];
            const dadosRestricoes = dados?.properties || dados;

            return dadosRestricoes.ano || '-';
        },
        formatarListaRestricoes(restricoes) {
            return restricoes?.resultadosAgrupados
                ? restricoes.resultadosAgrupados
                : [{ ...restricoes }];
        },
        aplicarZoomRestricao(index) {
            const restricaoResultadosAgrupados =
                this.restricoes[index]?.resultadosAgrupados?.[0] || null;
            const restricao =
                restricaoResultadosAgrupados || this.restricoes[index];
            const geometriaQueNaoEstavaDentroDasRestricoes = this.geometria
                ? this.geometria[index]
                : null;

            this.$emit(
                'aplicar-zoom-restricao',
                restricao,
                geometriaQueNaoEstavaDentroDasRestricoes,
                index
            );
        },
        numeralStringFormatTocpfCnpj(cpfCnpj) {
            return cpfCnpj
                ? formatters.numeralStringFormatTocpfCnpj(cpfCnpj)
                : '-';
        },
        existeDadosGeoEspaciais(restricao) {
            const { geometry, geometria, properties } = restricao;

            if (properties?.latitude && properties?.longitude) {
                return true;
            }

            if (restricao?.resultadosAgrupados) {
                const resultadosAgrupados = restricao?.resultadosAgrupados[0];

                return (
                    this.habilitarZoomRestricao &&
                    (resultadosAgrupados.geometry ||
                        resultadosAgrupados.geometria ||
                        resultadosAgrupados.properties?.latitude)
                );
            }

            return (
                this.habilitarZoomRestricao &&
                (geometry || geometria || this.geometria)
            );
        }
    }
};
</script>

<style lang="scss" scoped>
.restricao-id {
    display: flex;
    gap: 3px;
    font-size: 13px;
    &__label {
        font-weight: bold;
    }
    &__value {
        display: inline-block;
        word-break: break-word;
    }
}
.restricao-lista {
    margin-left: 33px;
    padding-bottom: 12px;
    & + & {
        padding: 12px 0;
        border-top: 1px solid #dbdbdb;
    }
    .restricao-dados {
        display: flex;
        gap: 4px;
        font-size: 13px;
        &__label {
            font-weight: bold;
        }
        &__value {
            display: inline-block;
            word-break: break-word;
        }
    }
}
</style>
